<template>
  <v-navigation-drawer
    v-model="$store.state.showMobileNav"
    class="pa-4"
    fixed
    color="#1c1c1c"
    right
  >
    <v-list nav color="#1c1c1c">
      <v-list-item>
        <v-spacer />
        <v-btn icon color="white" @click="$store.state.showMobileNav = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-list-item>
      <div class="mg-50" />
      <v-list-item>
        <router-link class="color-white opaque" to="/">Home</router-link>
      </v-list-item>
      <v-list-item>
        <router-link class="color-white opaque" to="/wwo"
          >What We Offer</router-link
        >
      </v-list-item>
      <v-list-item>
        <router-link class="color-white opaque" to="/insights"
          >Insights</router-link
        >
      </v-list-item>
      <v-list-item>
        <router-link class="color-white opaque" to="/about">About</router-link>
      </v-list-item>
      <!-- <v-list-item>
          <router-link class="color-white opaque" to="/people">People</router-link>
      </v-list-item>-->
      <v-list-item>
        <router-link class="color-white opaque" to="/contact"
          >Contact</router-link
        >
      </v-list-item>
      <v-list-item>
        <router-link class="color-white" to="/datavoucher"
          ><b>Data Voucher</b></router-link
        >
      </v-list-item>
      <v-list-item>
        <v-divider color="white" />
      </v-list-item>
      <v-list-item>
        <img :src="logo" class="logo" />
      </v-list-item>
      <v-list-item>
        <div class="text-3 color-white">
          (주)데이터몬스터즈
          <br />T. 044-865-6038 <br />E. contact@damons.kr
        </div>
      </v-list-item>
      <v-list-item>
        <div class="text-3 thin color-lightgrey opaque">
          Copyrights Data Monsters Inc. - All Rights Reserved
        </div>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import logo from "../assets/dmlogo.png";

export default {
  props: {
    showMobileNav: Boolean,
  },
  data: () => ({
    logo: logo,
  }),
};
</script>

<style>
</style>